import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import lotService from "../../services/lot-service";

import { Divider, message, Spin, Upload } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { UploadProps } from "antd";
import moment from "moment";
import axios from "axios";
import fileService from "../../services/file-service";
import { URL_BASE } from "../../config/url-server";
import { height } from "@mui/system";
import { ToastContainer, toast } from 'react-toastify';
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import Swal from "sweetalert2";




const UploadMovements = () => {



  const { Dragger } = Upload;
  const [file, setFile] = useState("NOK");
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  let navigate = useNavigate();
  const [farmName, setFarmName] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  ///Aplicaciones por dia
  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");
  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");
  const [listDocuments, setListDocuments] = useState([])

  const [lotName, setLotName] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const productList = [
    { id: "0", name: "-Escoja-" },
    { id: "Ana liquido", name: "Ana liquido" },
    { id: "Ana Solido", name: "Ana Solido" },
    { id: "Polen", name: "Polen" }
  ];



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
    }
  };

  const getListDocuments = async () => {
    setListDocuments([])
    const lot_id = getValues("lotId");
    const list = await fileService.documentsByLot(lot_id)
    if (list) {
      setListDocuments(list.data);
    };
  }



  const confirmDelete = async (documentId) => {

    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios!', { autoClose: 1000 });
      return;
    }


    Swal.fire({
      title: "Desea eliminar las tareas relacionadas a este documento?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Eliminar tareas",
      denyButtonText: `Conservar`
    }).then((result) => {
      if (result.isConfirmed) {
        deleteDocument(documentId)
      }
    });

  }


  const deleteDocument = async (documentId) => {
    await fileService.deleteDocument({ documentId })
    toast('Documento eliminado', { autoClose: 1000 });
    getListDocuments()
  }




  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE

  const uploadMovements = async (data) => {


    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios!', { autoClose: 1000 });
      return;
    }


    const product = getValues("product")
    if (product == "0") {
      toast.error('Seleccione un producto!', { autoClose: 1000 });
      return;
    }

    setLoading(true)
    const result = await fileService.insertMovemensByLot(data);
    if (result) {
      const success = result.data.success;
      const message = result.data.message;
      if (success) {

        toast.success(
          <div>
            {
              message.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
          </div>, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        setFile("");
        setFileList([]);
        setValue("document", "");
        getListDocuments()

      } else {
        toast.error(
          <div>
            {
              message.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
          </div>, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
      }
    }
    setLoading(false)
  };







  const verifyTitle = (fileName) => {
    let message = ""
    let lot_name = getValues("lotName");
    fileName = fileName.toUpperCase()
    lot_name = lot_name.toUpperCase()
    let result = fileName.includes("lot_name");
    if (!fileName.includes(lot_name)) {
      return "Titulo del excel no contiene: " + lot_name;
    }
    if (!fileName.includes("TAREAS")) {
      return "Titulo del excel no contiene la palabra: TAREAS ";
    }
    return "OK"
  }



  const props = {
    name: "file",
    height: "100px",
    multiple: false,
    fileList: fileList,
    accept: ".xlsx",
    maxCount: 1,
    action: URL_BASE + "file/upload",

    onChange(info) {


      const username = localStorage.getItem("username");
      if (username != "superadmin") {
        toast.error('Usuario sin privilegios!', { autoClose: 1000 });
        return;
      }



      const res = verifyTitle(info.file.name)
      if (res != "OK") {
        toast.error(res, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        return
      }



      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        const response = info.file.response;
        if (response && response.status === "success") {
          const { originalname, filename, path, size } = response.file;
          toast(`${originalname} subido exitosamente.`, { autoClose: 1000 });
          setValue("filename", originalname)
          setFile(filename);
          setValue("document", filename);
        } else {
          toast.error("Error en la respuesta del servidor.", {
            autoClose: false,
            onClick: () => {
              toast.dismiss();
            }
          });

        }
      } else if (status === "error") {
        toast.error("Error en la respuesta del servidor.", {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });

      }

      setFileList(info.fileList);
    },
    onRemove: async (e) => {
      try {
        const response = await axios.delete(
          `https://core.palmicultor.com.co/api/file/delete/${file}`
        );
        if (response.data.status === "success") {
          toast('Realizado.', { autoClose: 1000 });
          setFile("");
          setFileList([]);
          setValue("document", "");
        } else {


          toast.error(response.data.message, {
            autoClose: false,
            onClick: () => {
              toast.dismiss();
            }
          });

        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },
  };



  const getLot = async (lotId) => {
    const lot = await lotService.getLot(lotId);
    if (lot) {
      setValue("farmId", lot.farmId);
      setValue("farmName", lot.farmName);
      setValue("sectionId", lot.sectionId);
      setValue("sectionName", lot.sectionName);
      setValue("lotId", lot._id);
      setValue("lotCode", lot.lotCode);
      setValue("lotName", lot.name);
      setValue("density", lot.density);
      setLotId(lot._id)
      setLotName(lot.name)
      setShowSave(false);
      getListDocuments()
    }
  };




  const toUpperFieldName = (e) => {
    let value = e.target.value;
    setValue("name", value.toUpperCase());
  };



  useEffect(() => {
    getLisFarm();
  }, []);


  return (
    <div className="row px-3 pt-3 pb-3 bg-light ">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Ingresar movimientos desde excel</Divider>
      </div>


      <div className="col-12 col-sm-5 mb-3">

        <div className=" card p-4 ms-4">
          <form className="form-react" onSubmit={handleSubmit(uploadMovements)}>
            <div className="row">
              <div className="card-title">
                <h4>Datos del documento</h4>
                
                <label><b>Campos:</b> fecha, linea, palma, operario, cedula, 1ra, 2da, 3ra</label><br/>  
              </div>

              <div className=" col-12 col-sm-6">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className=" col-4 d-none">
                <label>Id Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmId")}
                />
              </div>


              <div className=" col-4 d-none">
                <label>Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmName")}
                />
              </div>




              <div className=" col-12 col-sm-6">
                <label className="text-secondary fw-bold">Seccion</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className=" col-4 d-none">
                <label>Id seccion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionId")}
                />
              </div>


              <div className=" col-4 d-none">
                <label>Nombre sección</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("sectionName")}
                />
              </div>


              <div className=" col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lote</label>
                <select
                  className="form-control text-secondary"
                  {...register("lot")}
                  onChange={(e) => {
                    const value = e.target.value;
                    getLot(value);
                  }}
                >
                  {listLots.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-4 d-none">
                <label>Id Lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotId")}
                />
              </div>




              <div className=" col-12 col-sm-6 ">
                <label>Producto</label>
                <select className="form-control" {...register("product")}>
                  {productList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-12 col-sm-6 d-none">
                <label>Codigo Lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotCode")}
                />
              </div>


              <div className=" col-4 d-none">
                <label>Nombre Lote</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lotName")}
                />
              </div>




              <div className=" col-12 col-sm-6 col-sm-4 d-none">
                <label>Densidad de siembra</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("density")}
                />
              </div>




              <div className=" col-12 col-sm-6 mt-1 d-none">
                <label>Document</label>
                <input
                  type="text"
                  readOnly={true}
                  onKeyUp={toUpperFieldName}
                  className="form-control bg-light"
                  {...register("document", { required: true, minLength: 3 })}
                />
              </div>


              <div className=" col-12 mt-1"> 
                <label>Nombre de archivo</label>
                <input
                  type="text"
                  readOnly={true}
                  onKeyUp={toUpperFieldName}
                  className="form-control bg-light"
                  {...register("filename", { required: true, minLength: 3 })}
                />
              </div>





              <div className="col-12 mt-4" style={{ height: '130px' }}>
                <div className="row">
                  <div className="col-12">
                    <Dragger {...props}>
                      <p className="ant-upload-drag-icon"></p>
                      <p className="ant-upload-text">
                        Click o arrastre para subir
                      </p>
                      <p className="ant-upload-hint">
                        Solo se aceptan archivos con extensión xlsx.
                      </p>
                    </Dragger>
                  </div>
                </div>
              </div>

             

              <div className="  col-12 col-sm-12">
                <label>&nbsp; </label>
                <Spin spinning={loading} >
                  <button className="btn btn-success w-100" type="submit">
                    <i className="bi bi-upload fa-lg m-4" /> Subir registros
                  </button>
                </Spin>
              </div>



            </div>
          </form>


        </div>


      </div>




      <div className="col-12 col-sm-7">
        <div className="card p-4">
          <div className="card-title ms-2">
            <h4 className="text-secondary mx-3">Documentos: {lotName}</h4>
            <div className="tbl-container bdr">

              <Spin spinning={loading}>
                <table className="table">
                  <thead className="table-primary">
                    <tr>
                      <th >Nombre documento</th>
                      <th >Fecha</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listDocuments.map((document) => (
                      <tr key={document._id}>
                        <td>{document.filename}</td>
                        <td>{document.createdAt.split("T")[0]}</td>
                        <td style={{ width: "180px" }}>

                          <button
                            className="btn btn-danger ms-2"
                            onClick={() => confirmDelete(document.documentId)}
                          >
                            <i className="bi bi-card-checklist fa-lg m-1" />
                            Eliminar documento
                          </button>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>

      </div>







    </div>
  );
};

export default UploadMovements;
